module.exports = __webpack_public_path__ + "static/media/memberships-shot-2.71b5d6bc.png";